'use client';

import Link from 'next/link';
import classNames from 'classnames';

import { IImage } from 'app/interfaces/common';
import ImageBg from 'app/components/common/ImageBg';

interface INewsCardCategory {
  name: string;
  slug: string;
}

export interface INewsCardProps {
  title: string;
  date_published?: string;
  category?: INewsCardCategory | null;
  image_preview?: IImage | null;
  slug: string;
  className?: string;
}

export default function NewsCard({
  title,
  date_published,
  category,
  image_preview,
  slug,
  className
}: INewsCardProps) {
  return (
    <Link
      className={classNames('group', className)}
      href={`/media/${category?.slug}/${slug}`}
    >
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden bg-graphite-dark rounded group isolate">
        {!!image_preview && (
          <div className="relative w-full h-full rounded group-hover:scale-105 transition-transform duration-700">
            <ImageBg
              src={image_preview.url}
              alt={image_preview.alt ?? ''}
              fill
              placeholderDataURL={image_preview.placeholder_data_url}
              className="object-cover rounded"
            />
          </div>
        )}
      </div>
      <div className="absolute top-0 left-0 grid grid-cols-[auto,_auto] grid-rows-[1fr,_auto] gap-5 md:gap-7 xl:gap-x-10 xl:gap-y-4 w-full h-full p-5 text-gray rounded">
        <div className="text-p2">{title}</div>
        {!!category && (
          <span className="justify-self-end self-start py-0.5 px-1.5 text-h2 text-white bg-brown rounded-[4px] ">
            {category.name}
          </span>
        )}
        <p className="col-[1_/_span_1] mb-auto text-p3 opacity-50">
          {date_published}
        </p>
      </div>
    </Link>
  );
}
